import React from 'react'
import { Col, Row, Table } from 'reactstrap'
import PriceUtil from 'utils/price-util'
import dayjs from 'dayjs'
import './customer-order-item-pdf.css'
import PropTypes from 'prop-types'
import { ITEM_STATUS } from 'domains/customer-order/constants'

const propTypes = {
  order: PropTypes.shape({
    number                    : PropTypes.string,
    order_date                : PropTypes.string,
    payment_method_name       : PropTypes.string,
    shipment_insurance_total  : PropTypes.number,
    shipment_cost_total       : PropTypes.number,
    sub_total                 : PropTypes.number,
    total                     : PropTypes.number,
    shipments                 : PropTypes.array,
    item_price_total          : PropTypes.number,
    item_discount_total       : PropTypes.number,
    item_tax_total            : PropTypes.number,
    order_items               : PropTypes.array,
    payment_method_rate_total : PropTypes.number
  })
}

const defaultProps = {
  order: {
    number                    : '',
    order_date                : '',
    payment_method_name       : '',
    shipment_insurance_total  : 0,
    shipment_cost_total       : 0,
    sub_total                 : 0,
    total                     : 0,
    shipments                 : [],
    order_items               : [],
    payment_method_rate_total : 0
  }
}

const CustomerOrderItemPdf = ({ order }) => (
  <div id='printOrderInvoice'>

    <div className='text-center'>
      <img
        src='/tinkerlust-logo.png'
        className='my-5'
        alt='tinkerlust-logo'
      />
    </div>

    <h2>
      { 'Order' }
    </h2>
    <Row>
      <Col>
        <div>
          { 'Nomor Invoice' }
        </div>
        <div>
          { order.number }
        </div>
      </Col>
      <Col>
        <div>
          { 'Tanggal' }
        </div>
        <div>
          { dayjs(order.order_date).format('dddd, DD/MMM/YYYY') }
        </div>
      </Col>
      <Col>
        <div>
          { 'Metode Pembayaran' }
        </div>
        <div>
          { order.payment_method_name }
        </div>
      </Col>
    </Row>

    <h2 className='mt-4'>
      { 'Shipments' }
    </h2>
    <Table
      striped
      className='mt-3'
      style={{ color: 'black' }}
    >

      <thead className='font-weight-bold'>
        <tr className='text-center table__header-bg'>
          <th>
            { 'Shipment No.' }
          </th>
          <th>
            { 'Metode Pengiriman' }
          </th>
          <th>
            { 'Nomor Tracking' }
          </th>
          <th>
            { 'Tujuan' }
          </th>
          <th>
            { 'Cost ' }
          </th>
        </tr>
      </thead>
      <tbody>
        {
          order.shipments.map((shipment) => (
            <tr className='table__border--black table__text--break' key={ shipment.number }>
              <td>
                { shipment.number }
              </td>
              <td>
                { `${shipment.courier} - ${shipment.courier_service_type}` }
              </td>
              <td>
                { shipment.tracking_no  }
              </td>
              <td>
                <div>
                  { shipment.recipient_name }
                </div>
                <div style={{ whiteSpace: 'normal' }}>
                  {
                    [
                      shipment.destination_street_address,
                      shipment.destination_kelurahan,
                      shipment.destination_kecamatan,
                      shipment.destination_kota,
                      shipment.destination_provinsi,
                      shipment.destination_kode_pos,
                      `T:  ${shipment.recipient_phone}`
                    ]. join(', ')
                  }
                </div>
              </td>
              <td>
                { PriceUtil.format(shipment.cost) }
              </td>
            </tr>
          ))
        }

        {
          order.shipment_insurance_total > 0 && (
            <tr className='table__border--black'>
              <td
                colSpan='4'
                className='text-right'
              >
                { 'SHIPMENT INSURANCE COST' }
              </td>
              <td>
                { PriceUtil.format(order.shipment_insurance_total) }
              </td>
            </tr>
          )
        }

        <tr className='table__border--black'>
          <td
            colSpan='4'
            className='text-right'
          >
            { 'SHIPMENT COST TOTAL' }
          </td>
          <td>
            { PriceUtil.format(order.shipment_cost_total) }
          </td>
        </tr>

      </tbody>
    </Table>

    <h2 className='mt-4'>
      { 'Order Items' }
    </h2>
    <Table
      striped
      className='my-3'
      style={{ color: 'black' }}
    >

      <thead className='font-weight-bold'>
        <tr className='text-center table__header-bg'>
          <th style={{ width: '62px' }}>
            { 'No.' }
          </th>
          <th>
            { 'Product' }
          </th>
          <th>
            { 'SKU' }
          </th>
          <th style={{ width: '62px' }}>
            { 'Qty' }
          </th>
          <th>
            { ' Price' }
          </th>
          <th>
            { 'Discount Amount' }
          </th>
          <th>
            { 'Tax Amount' }
          </th>
          <th>
            { 'Subtotal' }
          </th>
        </tr>
      </thead>

      <tbody>
        {
          order.order_items.map((item, index) => {

            const isOrderItemCancelled = item.status === ITEM_STATUS.CANCELLED

            if (!isOrderItemCancelled) {
              return (
                <tr className='table__border--black table__text--break' key={ item.name }>
                  <td>
                    { index + 1 }
                  </td>
                  <td>
                    { item.name }
                  </td>
                  <td>
                    { item.sku }
                  </td>
                  <td>
                    { item.quantity }
                  </td>
                  <td>
                    { PriceUtil.format(item.original_price) }
                  </td>
                  <td>
                    { PriceUtil.format(item.discount_amount) }
                  </td>
                  <td>
                    { item.tax_amount? PriceUtil.format(item.tax_amount) : '-' }
                  </td>
                  <td>
                    { PriceUtil.format(item.price) }
                  </td>
                </tr>
              )
            }
          })
        }

        <tr className='table__border--black'>
          <td
            colSpan='6'
            className='text-right'
          >
            { 'ITEM SUB TOTAL' }
          </td>
          <td colSpan='2'>
            { PriceUtil.format(order.item_price_total + order.item_discount_total + order.item_tax_total) }
          </td>
        </tr>


        <tr className='table__border--black'>
          <td
            colSpan='6'
            className='text-right'
          >
            { 'SHIPMENT COST TOTAL' }
          </td>
          <td colSpan='2'>
            { PriceUtil.format(order.shipment_cost_total + order.shipment_insurance_total) }
          </td>
        </tr>

        {
          order.payment_method_rate_total > 0 && (
            <tr className='table__border--black'>
              <td
                colSpan='6'
                className='text-right'
              >
                { 'CONVENIENCE FEE' }
              </td>
              <td colSpan={ 2 }>
                { PriceUtil.format(order.payment_method_rate_total) }
              </td>
            </tr>
          )
        }

        <tr className='table__border--black'>
          <td
            colSpan='6'
            className='text-right'
          >
            { 'GRAND TOTAL' }
          </td>
          <td colSpan='2'>
            { PriceUtil.format(order.total) }
          </td>
        </tr>

      </tbody>

    </Table>

    <div className='mt-5'>
        Cek status pengiriman di Customer Account Anda <a href='www.tinkerlust.com/account/orders'>www.tinkerlust.com/account/orders</a>
    </div>

  </div>
)

CustomerOrderItemPdf.propTypes    = propTypes
CustomerOrderItemPdf.defaultProps = defaultProps

export default  CustomerOrderItemPdf
